import React from "react"
import { Table, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableBody } from "material-ui"
import { IScheduleConstraint, EScheduleConstraintSeverity, EScheduleConstraintType } from "../../../models"
import strings from "../../../localization/strings"
import WarningIcon from "material-ui/svg-icons/alert/warning"
import ScheduleConstraintDetailCol from "./ScheduleConstraintDetailCol"
interface IProps {
	constraints: IScheduleConstraint[]
}

const ScheduleConstraintsTable: React.SFC<IProps> = (props) => {
	const getConstraintName = (constraintType: EScheduleConstraintType) => {
		switch (constraintType) {
			case EScheduleConstraintType.ConflictsWithSchedule:
				return strings.Employee_Already_Scheduled
			case EScheduleConstraintType.ConflictsWithLeave:
				return strings.Shift_Confilicts_with_Time_Off
			case EScheduleConstraintType.ConsecutiveShiftRuleViolation:
				return "not defined"
			case EScheduleConstraintType.EmployeeWillIncurOvertime:
				return "not defined"
			case EScheduleConstraintType.OutsideEmployeePreferredWorkTime:
				return "not defined"
			case EScheduleConstraintType.ShiftPunchLevelInvalid:
				return strings.The_punch_level_of_shift_invalid
			case EScheduleConstraintType.ConflictsWithWorkPreferences:
				return strings.Shift_conflicts_with_employee_work_preferences
			case EScheduleConstraintType.ConflictWithShiftPaytype:
				return strings.Employee_pay_group_does_not_contain_the_shift_paytype
			case EScheduleConstraintType.ConflictWithBreakPaytype:
				return strings.Employee_pay_group_does_not_contain_the_break_paytype
			case EScheduleConstraintType.ConflictWithHoliday:
				return strings.Shift_Confilicts_with_holiday
			case EScheduleConstraintType.ScheduleNameInvalid:
				return strings.Schedule_name_is_duplicated
			case EScheduleConstraintType.ShiftDateNotMatchWithJobDates:
				return strings.Shift_time_is_not_match_with_job_dates
			case EScheduleConstraintType.ShiftPunchLevelInvalidForEmployee:
				return strings.Employee_does_not_have_access_to_the_punch_level_of_shift
			case EScheduleConstraintType.ShiftTimeIsOutOfSchedule:
				return strings.Shift_time_is_out_of_schedule
			case EScheduleConstraintType.NoMatchShiftPosition:
				return strings.Employee_does_not_have_matched_position_with_shift
			case EScheduleConstraintType.NoMatchWithScheduleHierarchy:
				return strings.Shift_hierarchy_is_not_match_with_the_hierarchy_of_schedule_document
			case EScheduleConstraintType.NoMatchWithScheduleJob:
				return strings.Shift_job_is_not_match_with_the_job_of_schedule_document
			case EScheduleConstraintType.NoMatchWithScheduleClient:
				return strings.Shift_client_is_not_match_with_the_client_of_schedule_document
			case EScheduleConstraintType.ScheduleDateNotMatchWithJobDates:
				return strings.Schedule_dates_are_not_match_with_job_dates
			case EScheduleConstraintType.ConflictsWithExcludeWeekends:
				return strings.Shift_is_on_weekends
			case EScheduleConstraintType.InvalidAssignedEmployee:
				return strings.Assigned_employee_not_exist
		}
	}
	return (
		<Table selectable={false}>
			<TableHeader
				displaySelectAll={false}
				adjustForCheckbox={false}
				enableSelectAll={false}
			>
				<TableRow style={{ height: 40 }}>
					<TableHeaderColumn style={{ display: "flex", alignItems: "center", padding: 0, height: 40 }}>
						<WarningIcon style={{ color: "#FFC400", width: 25, height: 25, marginRight: 5 }} />
						<span>{strings.Schedule_Validation_Issues}</span>
					</TableHeaderColumn>
					<TableHeaderColumn style={{ padding: 0, height: 40, width: 50, textAlign: "center" }}>{strings.Details}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody displayRowCheckbox={false}>
				{props.constraints
					.sort((a, b) => {
						if (a.Severity === EScheduleConstraintSeverity.Error && b.Severity !== EScheduleConstraintSeverity.Error) {
							return -1
						}
						if (a.Severity !== EScheduleConstraintSeverity.Error && b.Severity === EScheduleConstraintSeverity.Error) {
							return 1
						}
						if (a.Severity === b.Severity) {
							return 0
						}
					})
					.map((constraint, index) =>
						<TableRow key={index} style={{ height: 30, borderBottom: "none" }}>
							<TableRowColumn style={{ padding: 0, height: 30, color: constraint.Severity === EScheduleConstraintSeverity.Error && "red" }}>
								{constraint.Severity === EScheduleConstraintSeverity.Error ?
									`${index + 1}) ${strings.Error}: ${getConstraintName(constraint.Type)}` :
									`${index + 1}) ${getConstraintName(constraint.Type)}`
								}
							</TableRowColumn>
							<TableRowColumn style={{ padding: 0, height: 30, width: 50, textAlign: "center" }}>
								<ScheduleConstraintDetailCol
									constraint={constraint}
									orderKey={String(index)}
								/>
							</TableRowColumn>
						</TableRow>
					)}
			</TableBody>
		</Table>
	)
}

export default ScheduleConstraintsTable